import { render } from "./SmallCardComp.vue?vue&type=template&id=0e3b25c1&scoped=true&ts=true"
import script from "./SmallCardComp.vue?vue&type=script&lang=ts"
export * from "./SmallCardComp.vue?vue&type=script&lang=ts"

import "./SmallCardComp.vue?vue&type=style&index=0&id=0e3b25c1&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3b25c1"]])

export default __exports__